import React, { ReactNode } from 'react';
import { ReactComponent as CheckCircleGreen } from '../../../assets/images/icons/check-circle-green.svg';
import { useAppTranslation } from '../../../i18n';

interface IdentificationMethodCardProps {
	id?: string;
	icon: ReactNode;
	title: string;
	description: string;
	trustText: string;
	onClick: () => void;
	disabled?: boolean;
	required?: boolean;
}

export const IdentificationMethodCard = ({
	id,
	icon,
	title,
	description,
	trustText,
	onClick,
	disabled,
	required
}: IdentificationMethodCardProps) => {
	const { t } = useAppTranslation();

	return (
		<div
			id={id}
			className="w-full flex items-center gap-3 rounded-xl border border-gray-200 p-3 sm:p-4"
		>
			<div className="flex-shrink-0 flex items-center justify-center w-[64px] h-[64px] sm:w-[72px] sm:h-[72px] rounded-lg bg-[#eef3fb]">
				{icon}
			</div>

			<div className="flex flex-col min-w-0 flex-1 gap-0.5">
				<div className="flex items-center gap-2 flex-wrap">
					<p className="text-lg font-[700] text-gray-800 leading-tight">{title}</p>
					{required && (
						<span className="text-[10px] font-[600] uppercase tracking-wide text-red-600 bg-red-50 border border-red-200 rounded px-1.5 py-0.5">
							{t('steps.bank-auth-type-selection.required-badge')}
						</span>
					)}
				</div>
				<p className="text-sm text-gray-500 leading-snug whitespace-pre-line">{description}</p>
				<div className="flex items-center gap-1.5 mt-1.5">
					<CheckCircleGreen className="w-4 h-4 flex-shrink-0" />
					<span className="text-xs text-gray-500">{trustText}</span>
				</div>
			</div>

			<button
				onClick={onClick}
				disabled={disabled}
				aria-label={`${t('button.select')} – ${title}`}
				className="flex-shrink-0 self-start text-sm font-[500] text-gray-800 border border-gray-300 rounded-md px-3 sm:px-4 py-2 hover:bg-gray-50 focus:outline-none disabled:opacity-50"
			>
				{t('button.select')}
			</button>
		</div>
	);
};

export default IdentificationMethodCard;
